export const BOOKING_NOTE_STATUS = {
    NEW: 'new',
    RESIGNED: 'resigned',
    CANCELED: 'canceled',
    ENDED_PREMATURELY: 'ended_prematurely',
    REBOOKED: 'rebooked',
    DRAFT: 'draft',
} as const;

export const EXTERNAL_BOOKING_NOTE_STATUS = {
    CURRENT: 'aktuell',
    PAST: 'vergangen',
} as const;

export const BOOKING_NOTE_PEDESTAL_WEEK = {
    NONE: 'none',
    STANDARD: 'standard',
    EXTENDED: 'extended',
} as const;

export type BookingNoteStatus = typeof BOOKING_NOTE_STATUS[keyof typeof BOOKING_NOTE_STATUS];
export type ExternalBookingNoteStatus = typeof EXTERNAL_BOOKING_NOTE_STATUS[keyof typeof EXTERNAL_BOOKING_NOTE_STATUS];
export type BookingNotePedestalWeek = typeof BOOKING_NOTE_PEDESTAL_WEEK[keyof typeof BOOKING_NOTE_PEDESTAL_WEEK];

export interface BookingNoteChild {
    id: number
    fullName: string
    firstName: string
    lastName: string
    dateOfBirth?: string
    studentNumber?: string
}

export interface ParentUser {
    id: number
    fullName: string
    firstName: string
    lastName: string
    street?: string
    zip?: string
    city?: string
    email?: string
    phone?: string
}

export interface BookingNote {
    id: number
    createdAt: string
    bookingDate: string
    child: BookingNoteChild
    parentUser?: ParentUser
    status: BookingNoteStatus
    start: string
    end: string
    schoolYear: SchoolYear
    pedestalWeek: BookingNotePedestalWeek
    numStandardWeeks: number
    numExtendedWeeks: number
    number?: string
    times: Record<number, string[]>
    lunch: boolean
    inclusion: boolean
}

export interface SchoolYear {
    id: number
    name: string
    start: string
    end: string
}

export interface ExternalBookingNoteStudent {
    number: number
    name: string
    firstName: string
    lastName: string
    dateOfBirth: string
}

export interface ExternalBookingNoteGuardian {
    fullName: string
    firstName: string
    lastName: string
}

export interface ExternalBookingNoteAddress {
    postBox: string
    street: string
    houseNumber: string
    zipCode: string
    city: string
}

export interface ExternalBookingNoteContact {
    email: string
    phone: string
}

export interface ExternalBookingNoteSchool {
    number: string
    locationNumber: string
    name: string
}

export interface ExternalBookingNoteClass {
    grade: number
    name: string
}

export interface ExternalBookingNotePeriod {
    start: string
    end: string
}

export interface ExternalBookingNoteModules {
    baseWeek0618: boolean
    baseWeek0816: boolean
    early0607: boolean
    early0708: boolean
    coreTime: boolean
    late1617: boolean
    late1718: boolean
    holidayWeeks0618: number
    holidayWeeks0816: number
    lunchCatering: boolean
    inclusion: boolean
}

export interface ExternalBookingNoteDays {
    monday: boolean
    tuesday: boolean
    wednesday: boolean
    thursday: boolean
    friday: boolean
}

export interface ExternalBookingNote {
    id: number
    bookingId: number
    type: string
    status: ExternalBookingNoteStatus
    recordedAt: string
    historicized: boolean
    cancelled: boolean
    student: ExternalBookingNoteStudent
    guardian: ExternalBookingNoteGuardian
    address: ExternalBookingNoteAddress
    contact: ExternalBookingNoteContact
    school: ExternalBookingNoteSchool
    class: ExternalBookingNoteClass
    period: ExternalBookingNotePeriod
    modules: ExternalBookingNoteModules
    days: ExternalBookingNoteDays
    carrierDay: string
    schoolYear: string | null
}

export interface MatchedPair {
    internal: BookingNote
    external: ExternalBookingNote
    isEqual: boolean
}

export interface PotentialChildMatch {
    id: number
    firstName: string
    lastName: string
    dateOfBirth: string
    studentNumber?: string
    isExactMatch?: boolean
}
